import React from "react";
import Redeemrequest from "../components/redeemrequest";
export function RedeemrequestPage() {
  return <Redeemrequest />;
}
export default RedeemrequestPage;
